import React from 'react';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import SearchIcon from '@material-ui/icons/Search';
import MainButton from '../../MUI/MainButton';
import TextMaskCustom from '../../MUI/TextMaskCustom';
import TextInputFieldWithValidation from '../../ValidationFormElements/TextInputFieldWithValidation';

import useStyles from './makeStyles';

const PolicySearchForm = ({ formProps, setPolicyNumber, policyNumber, isLoading, gridSize }) => {
  const { handleSubmit, errors, clearError, setValue, triggerValidation, onSubmit } = formProps;

  const classes = useStyles();

  return (
    <Grid container spacing={1}>
      <Grid item flex={1} xs={gridSize} className={classes.searchMaskInput}>
        <TextInputFieldWithValidation
          placeholder="AA/000000"
          formProps={{ errors, clearError }}
          labelKey="recurrPayment.searchInput"
          name="policyNumber"
          value={policyNumber.toUpperCase()}
          handleChange={(e) => {
            const val = e.target.value;
            setValue('policyNumber', val, errors.policyNumber);
            setPolicyNumber(val);
            triggerValidation({ name: 'policyNumber' });
          }}
          required
          InputProps={{
            inputComponent: TextMaskCustom,
            inputProps: {
              handler: 'policyNumberInputMask',
            },
          }}
        />
      </Grid>
      <Grid>
        <MainButton
          onClick={handleSubmit(onSubmit)}
          type="submit"
          disabled={isLoading}
          className={classes.formButton}
          variant="contained"
          color="primary"
        >
          <SearchIcon className={classes.svg} />
        </MainButton>
      </Grid>
    </Grid>
  );
};

PolicySearchForm.propTypes = {
  formProps: PropTypes.shape({
    handleSubmit: PropTypes.func.isRequired,
    errors: PropTypes.shape({
      policyNumber: PropTypes.shape({}),
    }).isRequired,
    clearError: PropTypes.func.isRequired,
    setValue: PropTypes.func.isRequired,
    triggerValidation: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
  }).isRequired,
  setPolicyNumber: PropTypes.func.isRequired,
  policyNumber: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  gridSize: PropTypes.number.isRequired,
};

export default PolicySearchForm;
